module.exports = __webpack_public_path__ + "media/universities/HEC-26853173.png";